import { VersionHistoryTab } from '../components/settings/VersionHistoryTab';

export function VersionHistoryPage() {
  return (
    <div className="max-w-4xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">Version History</h1>
        <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">Release notes and changelog for CloudIncidents</p>
      </div>
      <VersionHistoryTab />
    </div>
  );
}
